module.exports = __webpack_public_path__ + "static/media/laptop-code.92aaee00.svg";